import { render, staticRenderFns } from "./NewUserDutyModal.vue?vue&type=template&id=295ae486&scoped=true&lang=pug"
import script from "./NewUserDutyModal.vue?vue&type=script&lang=js"
export * from "./NewUserDutyModal.vue?vue&type=script&lang=js"
import style0 from "./NewUserDutyModal.vue?vue&type=style&index=0&id=295ae486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295ae486",
  null
  
)

export default component.exports